import React from 'react';
var CardSkeleton = function (props) {
    var small = props.small;
    return (React.createElement("div", { className: "card card-dnvgl skeleton-card " + (small ? 'card-small' : 'card-narrow') }, !small ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "skeleton-line card-img-top" }),
        React.createElement("div", { className: "card-body" },
            React.createElement("span", { className: "skeleton-line skeleton-h-xl" }),
            React.createElement("span", { className: "skeleton-line skeleton-h-md mb-3" }),
            React.createElement("span", { className: "skeleton-line skeleton-h-md w-75" }),
            React.createElement("span", { className: "skeleton-line skeleton-h-md" })))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "skeleton-line card-img" }),
        React.createElement("div", { className: "card-body" },
            React.createElement("span", { className: "skeleton-line skeleton-h-xl" }),
            React.createElement("span", { className: "skeleton-line skeleton-h-md" }))))));
};
export default React.memo(CardSkeleton);
